import { useParameterStore } from "@/frontend/store/ParameterStore";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { ContainerTreeObject } from "@/frontend/types/navigationTypes";
import { scrollToElement } from "@/frontend/utils/scrollTo";
import { I18n } from "@/i18n/I18n";
import { Status } from "@/types/containerTypes";
import { Step } from "@/backend/models/containers/step";
import { useState, useEffect } from "react";
import { useShallow } from "zustand/react/shallow";
import { Select } from "../Select";
import { StepItemRunBody } from "./StepItemRunBody";
import { StepItemRunHeader } from "./StepItemRunHeader";
import { useStepStatusColor } from "@/frontend/hooks/useStepStatusColor";


export function RepeatingStepRun(props: { initItem: ContainerTreeObject, finishStep: () => void, collapsible?: boolean }) {
  const { initItem, finishStep, collapsible } = props;

  const completeRepeatingStep = useTreeStore((state) => state.completeRepeatingStep);
  const repeatingStep = useTreeStore(useShallow(state => state.containerLookup[initItem.container.id]));
  const repeatingStepChildren = repeatingStep.children.filter(child => child.container.isRepeatingStepChild());
  const [index, setIndex] = useState(repeatingStepChildren.length - 1);
  const currentChild = repeatingStepChildren[index];
  const repeatingParameter = useParameterStore(useShallow(state => state.parameters.find(param => param.id === repeatingStep.container.rangeParameterId)));
  const [showStep, setShowStep] = useState(currentChild?.container.status === Status.PENDING);
  const statusColor = useStepStatusColor(currentChild?.container);

  useEffect(() => {
    setIndex(repeatingStepChildren.length - 1);
  }, [repeatingStepChildren.length]);

  if (!currentChild) return null;

  const completeRepeatingStepWrapper = async () => {
    const response = await completeRepeatingStep(repeatingStep.container.id, { index: index + 1 });
    if (!response.nextStep && index === repeatingStepChildren.length - 1) {
      finishStep();
      setShowStep(false);
    } else {
      scrollToElement(repeatingStep.id);
      document.getElementsByClassName('wizard-disable-container')?.[0]?.scrollTo(0, 0);
      setIndex(index + 1);
    }
  };

  return (
    <div className={statusColor}>
      <StepItemRunHeader
        step={currentChild.container as Step}
        setShowStep={collapsible ? setShowStep : undefined}
        showStep={showStep}
      />
      { (showStep || !collapsible) && <div>
        {repeatingParameter && <div className='d-flex gap-2 pt-3 ps-3 align-items-center'>
          <Select label="" value={I18n.get('cycle', { number: String(index + 1) })} minWidth="80px">
            {repeatingStepChildren.map((child, childIndex) => <button className="dropdown-item" key={child.id} type="button" onClick={() => setIndex(childIndex)}>{I18n.get('cycle', { number: String(childIndex + 1) })}</button>)}
          </Select>
          {I18n.get('ofTotal', { total: String(repeatingParameter.getFields().length) })}
        </div>}
        <StepItemRunBody step={currentChild} onUpdateStatus={() => void completeRepeatingStepWrapper()} />
      </div>}
    </div>
  );
}

